import React from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box,
  Avatar,
} from '@mui/material';
import {
  Menu as MenuIcon,
  Business as BusinessIcon,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks';

interface CompanyHeaderProps {
  onMenuClick: () => void;
  showMenuButton?: boolean;
}

export const CompanyHeader: React.FC<CompanyHeaderProps> = ({
  onMenuClick,
  showMenuButton = false,
}) => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleProfileClick = () => {
    navigate('/company/profile');
  };

  return (
    <AppBar
      position="fixed"
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        backgroundColor: '#FFFFFF',
        borderBottom: '1px solid #E5E7EB',
        boxShadow:
          '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
        width: '100%', // 全幅に設定
      }}
    >
      <Toolbar>
        {/* メニューボタン（モバイル・タブレット用） */}
        {showMenuButton && (
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={onMenuClick}
            sx={{
              mr: 2,
              color: '#374151',
              '&:hover': {
                backgroundColor: '#F3F4F6',
              },
            }}
          >
            <MenuIcon />
          </IconButton>
        )}

        {/* ロゴ・タイトル */}
        <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
          <BusinessIcon sx={{ color: '#2E5BBA', mr: 1, fontSize: 28 }} />
          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{
              color: '#111827',
              fontWeight: 'bold',
              fontSize: '1.25rem',
            }}
          >
            ガクフドキャリア
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: '#6B7280',
              ml: 2,
              fontSize: '0.875rem',
            }}
          >
            企業管理画面
          </Typography>
        </Box>

        {/* ユーザーメニュー */}
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <IconButton
            size="large"
            aria-label="account of current user"
            onClick={handleProfileClick}
            sx={{
              color: '#374151',
              '&:hover': {
                backgroundColor: '#F3F4F6',
              },
            }}
          >
            <Avatar
              sx={{
                width: 32,
                height: 32,
                backgroundColor: '#2E5BBA',
                fontSize: '0.875rem',
              }}
            >
              {user?.email?.charAt(0).toUpperCase() || 'U'}
            </Avatar>
          </IconButton>
        </Box>
      </Toolbar>
    </AppBar>
  );
};
